import { createContext } from "react";

const letcContext = createContext();

export default letcContext;
